<template>
  <div class="favorite-control" @click.stop>
    <button type="button" class="favorite-button" :disabled="!active || busy" :aria-pressed="saved ? 'true' : 'false'" :aria-label="`${saved ? 'Прибрати з обраного' : 'Додати в обране'}: ${product.name}`" @click="toggle">
      <heart-icon size="20" :fill="saved ? 'currentColor' : 'none'" aria-hidden="true" />
    </button>
    <p v-if="error" class="favorite-error" role="alert">{{ error }}</p>
  </div>
</template>
<script>
import { HeartIcon } from 'vue-feather-icons';
export default {
  components: { HeartIcon },
  props: { product: { type: Object, required: true }, active: { type: Boolean, default: true } },
  data: () => ({ error: '' }),
  computed: {
    saved() { return this.$store.getters.favorites.some(item => String(item.id) === String(this.product.id)); },
    busy() { return this.$store.getters.favoritesBusy; },
  },
  methods: {
    async toggle() {
      this.error = '';
      try { await this.$store.dispatch('toggleFavorite', this.product); }
      catch (error) { this.error = this.$store.getters.favoritesError || (error.status === 401 || error.status === 403 ? 'Відкрийте магазин з Telegram-бота.' : 'Не вдалося зберегти. Спробуйте ще раз.'); }
    },
  },
};
</script>
<style scoped>
.favorite-control { position: relative; }
.favorite-button { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; border: 1px solid #ddd; border-radius: 8px; background: #fff; color: #075a63; cursor: pointer; }
.favorite-error { font: 12px/18px Inter, sans-serif; color: #a12424; padding: 4px; }
</style>
